import React, { useCallback } from 'react';

// GLOBAL FUNCTIONS
import { apiFetch, makePath, modalFunctions } from 'functions.js';

// GLOBAL HELPERS
import useRecordView from 'helpers/getRecordView';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';

// STYLES
import { useRecordContext } from 'helpers/getRecordData';
import { capitalize } from 'lodash';
import { useNavigate } from 'react-router-dom';
import Page from 'parts/page/Page';


// MAIN COMPONENT
const RecordButtons = ({
  backPathname,
  saveButton = {},
  cancelButton = {},
  deleteButton = {},
  deleteModal = false,
}) => {

  // CONTEXT
  const { isEdit } = useRecordView();
  const { endpoints, recordID, recordLabel } = useRecordContext();

  // REACT ROUTER
  const navigate = useNavigate();

  // CALLBACKS
  const handleCancelClick = useCallback(
    () => backPathname ? navigate(backPathname) : navigate(-1),
    [backPathname, navigate]
  );

  const handleCustomErrorMessage = useCallback((error) =>
    modalFunctions.error(error.errors[0] || `Could not delete ${recordLabel}`),
    [recordLabel])

  const handleDelete = useCallback(
    () => {
      apiFetch({
        method: 'DELETE',
        endpoint: makePath(endpoints.remove, recordID),
        loadingMessage: `Deleting ${recordLabel}`,
        successMessage: `${capitalize(recordLabel)} deleted`,
        errorMessage: handleCustomErrorMessage,
        onSuccess: handleCancelClick,
      });
    },
    [endpoints, recordID, recordLabel, handleCancelClick, handleCustomErrorMessage]
  );
  const handleDeleteClick = useCallback(
    () => {
      if (deleteModal) modalFunctions.add({
         type: 'confirmation',
         title: 'Confirm Delete',
         body: `Are you sure you want to delete this ${recordLabel}?`,
         closeButton: false,
         continueButton: {
           label: 'Confirm',
           onClick: handleDelete
         }
       });
       else handleDelete()
    },
    [deleteModal, recordLabel, handleDelete]
  )

  // RENDER
  return (
    <Page.Buttons>
      <Button.Save
        {...saveButton}
      />
      <Button.Cancel
        onClick={handleCancelClick}
        {...cancelButton}
      />
      {!isEdit || !deleteButton ? null : (
        <Button.Delete
          onClick={handleDeleteClick}
          {...deleteButton}
        />
      )}
    </Page.Buttons>
  );
};

// EXPORT
export default RecordButtons;
